import React, { useEffect, useState, createRef, useRef } from 'react';
//Components
import Conector from './Components/Conector';
import "../../assets/css/fluxograma.css";

export default function Fluxogram({ nodes = [], onClickAdicionar, onClickConector, containerRef = null }) {
    const [nodesOrganizados, setNodesOrganizados] = useState([]);

    const [refLinhas, setRefLinhas] = useState([]);

    //Estado que define a maior quantidade de itens por linha
    const [maiorQtdItensLinha, setMaiorQtdItensLinha] = useState(0);

    const organizarNodes = () => {
        //Inserindo o valor das linhas nos nodes
        let _nodes = [];
        let nodesNaoAdicionados = [...nodes];
        //Preenchendo a primeira linha de nodes
        _nodes.push(...nodes.filter(value => !value.hashPai).map(value => {
            value.linha = 1;
            nodesNaoAdicionados = nodesNaoAdicionados.filter(nodeRemovido => !(nodeRemovido.hash == value.hash && nodeRemovido.hashPai == value.hashPai));
            return value;
        }));

        //Preenchendo as outras linhas
        let linhaAtual = 2;

        //Enquanto existir nodes na linha anterior que possuam filhos para as proximas linhas as linhas serão organizadas
        while (nodesNaoAdicionados.length > 0) {

            const nodesLinhaAnterior = _nodes.filter(value => value.linha == linhaAtual - 1);

            nodesLinhaAnterior.map(nodeAnterior => {

                const nodesComLinha = nodesNaoAdicionados.filter(value => nodeAnterior.hash == value.hashPai).map(value => {
                    value.linha = linhaAtual;
                    return value;
                });

                nodesComLinha.map(nodeComLinha => {
                    if (!_nodes.some(node => nodeComLinha.hash === node.hash && nodeComLinha.hashPai === node.hashPai)) {
                        nodesNaoAdicionados = nodesNaoAdicionados.filter(nodeRemovido => !(nodeRemovido.hash == nodeComLinha.hash && nodeRemovido.hashPai == nodeComLinha.hashPai));
                        _nodes.push(nodeComLinha);
                    }
                })

            });

            linhaAtual++;
        }
        //Organizando as linhas
        const maiorLinha = _nodes.sort((a, b) => b.linha - a.linha)[0].linha;


        let _nodesOrganizados = [];

        linhaAtual = 1;
        const _refLinhas = [];

        while (linhaAtual <= maiorLinha) {
            _refLinhas.push(createRef(null));
            if (linhaAtual <= 2) {
                _nodesOrganizados.push(_nodes.filter(value => value.linha === linhaAtual).map((value, index) => {
                    value.posicaoLinha = index + 1;
                    value.ref = createRef(null);
                    return value;
                }));
            } else {
                const nodesLinhaAnterior = _nodes.filter(value => value.linha === linhaAtual - 1);
                const nodesLinhaAtual = _nodes.filter(value => value.linha === linhaAtual);
                let posicaoLinha = 1;
                const linhaOrganizada = [];
                nodesLinhaAnterior.map(linhaAnterior => {
                    linhaOrganizada.push(...nodesLinhaAtual.filter(linhaAtual => linhaAtual.hashPai === linhaAnterior.hash)
                        .map((value) => {
                            value.posicaoLinha = posicaoLinha;
                            value.ref = createRef(null);
                            posicaoLinha++;
                            return value;
                        }));
                });
                _nodesOrganizados.push(linhaOrganizada);
            }

            linhaAtual++;
        }
        setRefLinhas(_refLinhas);
        _nodesOrganizados.map(linha => {
            if (linha.length > maiorQtdItensLinha) {
                setMaiorQtdItensLinha(linha.length);
            }
        });
        setNodesOrganizados(_nodesOrganizados);
    }
    useEffect(() => {
        organizarNodes();
    }, [nodes]);
    return (
        <div style={{ height: `60vh`, overflowY: "scroll" }} >
            <div ref={containerRef} className='fluxograma-container' style={{ height: `${(nodesOrganizados.length * 30) + 60}vh`, width: maiorQtdItensLinha * 3000 + "px" }} >
                {
                    nodesOrganizados.map((linha, index) => {
                        const espacoEntreLinhas = 180;
                        return (
                            <div ref={refLinhas[index]} key={index} style={{ position: "absolute", top: `${(index * espacoEntreLinhas) + (index == 0 ? 20 : 0)}px`, display: "flex", alignItems: "center", justifyContent: "space-around", width: linha.length * 450 + "px" }}>
                                {linha.map((value, indexItem) => {
                                    let _nodeFilho = null;
                                    nodesOrganizados.map((linha, indexLinha) => {
                                        if (linha.filter(node => node.name == value.name && indexLinha < index).length > 0)
                                            _nodeFilho = linha.filter(node => node.name == value.name && indexLinha < index)[0];
                                    });

                                    if (!!_nodeFilho && index != 0) {

                                        return null
                                    }

                                    return (
                                        <div key={indexItem} ref={value.ref} className={`shadow fluxogram-node ${value.etapaInicial ? "inicial" : ""} ${value.etapaFinal ? "final" : ""}`}>
                                            {value.name}
                                            {onClickAdicionar && !value.etapaFinal && <span role='button' className={"btnAdicionarNode shadow"} onClick={() => onClickAdicionar(value.hash)}>+</span>}
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    })
                }
                {
                    nodesOrganizados.length > 0 &&
                    nodesOrganizados.map((linha, index) => {
                        if (index == 0)
                            return null;

                        return linha.map((node, indexNode) => {
                            let linhaNodePai = null;
                            let linhaNodeFilho = null;
                            let nodeFilho = null;

                            nodesOrganizados.map((linha, indexLinha) => {
                                linha.map(nodeLinha => {
                                    if (nodeLinha.hash == node.hash && nodeFilho == null) {
                                        linhaNodeFilho = indexLinha;
                                        nodeFilho = { ...nodeLinha };
                                    }
                                    if (nodeLinha.hash == node.hashPai && linhaNodePai == null) {
                                        linhaNodePai = indexLinha;
                                    }
                                });
                            });
                            nodeFilho.textoConector = node.textoConector;
                            let nodePai = nodesOrganizados[linhaNodePai].filter(item => item.hash == node.hashPai)[0];

                            return (
                                <Conector onClickConector={() => onClickConector(node.hash, node.hashPai)} name={node.textoConector} key={indexNode} node1={nodePai} node2={nodeFilho} containerRef={containerRef} linha1={refLinhas[linhaNodePai]} linha2={refLinhas[linhaNodeFilho]} />
                            )
                        });

                    })
                }
            </div>
        </div>
    )
}